import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import Page from '../../components/Page';
import PageHeader from '../../components/PageHeader';
import Spacer from '../../components/Spacer';  
// import useBasisCash from '../../hooks/useBasisCash';

import moment from 'moment'
import Notice from '../../components/Notice';
// import useArticles,{ fetchArticles, useTokenInfo } from '../../hooks/useArticles';
// import { Question } from './components/Question'
import InfiniteScroll from 'react-infinite-scroller';
import _, { filter } from 'lodash'
import { Cron } from "croner";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts/core';
import { reaction } from 'mobx';
import stores from '../../state';
import { Empty, Spin, Button, message } from 'antd';
// import { Article } from '../../views/Home/components/Article'
import Articles, { Context } from '../../contexts/Articles';
import DocumentTitle from 'react-document-title'
// // import { useConfig } from '../../hooks/useConfig';;
import Parse from 'parse'
// // import useMessage from '../../hooks/useMessage';
import ZsxqEmpty from '../../components/ZsxqEmpty'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import sleep from 'sleep-promise';

import wingoPic from './img/wingo.webp'
import k3Pic from './img/k3.webp'
import _5dPic from './img/5d.webp'
import trxwingoPic from './img/trxwingo.webp'
import { base } from '../../hooks/usePlanners';
import { blue } from '../../theme/colors';
import { useHourlyActiveUser } from '../../hooks/useHourlyActiveUser';
import active_user_bg from './img/active_user.svg'

import { HitRatePanel } from './HitRatePanel';
import { PopularLotteryPrediction } from './PopularLotteryPrediction';
import { Advantages } from './Advantages';
import { WinningRanks } from './WinningRanks';
import { StyledHomeTopBackgroundWrapper } from '../Draw/Draw';
import LotterySegmentTab from '../../components/LotterySegmentTab';
import { useTranslation } from 'react-i18next';

const GoButton: React.FC = ()=>{
  return <div style={{borderRadius:20,borderColor:'white',borderWidth:1,color:'white',borderStyle:'solid',paddingLeft:20,paddingRight:20,marginBottom:20,marginTop:-20,marginLeft:'40%',fontSize:16,fontWeight:'bold'}}>GO {'>'}</div>
}


const ActiveUserPanel = ()=>{
  const {data:hau} = useHourlyActiveUser()
  const [chartData,setChartData] = useState<number[]>()
  const [xAxisData,setXAxisData]= useState<string[]>()
  
  useEffect(()=>{
    if(!hau){
      return
    }
    
    const currentTimeZone = moment().utcOffset();
    const xaixsData:string[] = []
    const chartData:number[] = []
    _.take(hau,24).reverse().forEach(item=>{
      const d = new Date()
      const [year,month,day,hour] = item.time.split('_')
      const m = moment()
      m.utcOffset(0)
      m.year(parseInt(year))
      m.month(parseInt(month))
      m.day(parseInt(day))
      m.hour(parseInt(hour))
       
      console.log('hour',hour,item.time,m.toDate())
      m.utcOffset(currentTimeZone) 
      xaixsData.push(m.format('HH:00'))
      chartData.push(item.hau)
    }) 
    setXAxisData(xaixsData)
    setChartData(chartData)
  },[hau])
  const {t} = useTranslation()
  return <div style={{alignSelf:'stretch'}}>
    <div style={{display:'flex',flexDirection:'row',alignItems:'center',fontWeight:'bold'}}> 
      <img src={active_user_bg} style={{width:20,height:20,marginLeft:10,marginRight:10}}/>{t('Active User')}
    </div>
    <div style={{alignSelf:'stretch',backgroundColor:'white',borderRadius:10,margin:10,height:210,boxShadow:'0px 6px 12px rgba(0, 0, 0, 0.08)'}}>
      
      {chartData && <ReactECharts option={{
    title: {
      left: 'center',
      // text: 'Tootip 1and dataZoom on Mobile Device'
    },
    legend: {
      top: 'bottom',
      data: ['Intention']
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross'
      }
    },
    // toolbox: {
    //   left: 'center',
    //   itemSize: 25,
    //   top: 55,
    //   feature: {
    //     dataZoom: {
    //       yAxisIndex: 'none'
    //     },
    //     restore: {}
    //   }
    // },
    xAxis: {
      type: 'category',
      boundaryGap:false,
      data:xAxisData,
      
      
      axisLabel: {
        inside: false,
        // formatter:(val:string,index:number)=>val
      },
    
      splitLine: {
        show: true
      },
    },
    yAxis: {
      type: 'value',
      axisTick: {
        inside: true
      },
      splitLine: {
        show: true
      },
      axisLabel: {
        inside: false,
        formatter: (val:number,index:number)=>val>1000? (Math.floor(val/1000)+'K'):val
      },
      z: 0
    },
    grid: {
      top: 20,
      left: 50,
      right: 10,
      height: 160
    },
    dataZoom: [
      {
        type: 'inside',
        throttle: 50
      }
    ],
    series: [
      
      {
        name: t('Active User'),
        type: 'line',
        smooth: true,
        stack: 'a',
        symbol: 'circle',
        symbolSize: 0,
        sampling: 'average',
        itemStyle: {
          color: blue[900]
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: blue[900]
            },
            {
              offset: 1,
              color: blue[100]
            }
          ])
        },
        data: chartData
      }
    ]
    }} />}
    </div>
  </div>
}

const DescItem:React.FC<{content:string,hideEmphasis?:boolean}> = ({content,hideEmphasis=false})=>{
  return <div style={{alignSelf:'stretch',display:'flex',flexDirection:'row',paddingLeft:10,paddingRight:10}}>
    <div style={{minWidth:7,height:7,background:hideEmphasis?'transparent':blue[900],marginTop:10,marginRight:10,
      transform:'rotate(45deg)'
      }}/> 
    <div style={{flex:1,color:'#646C7B',marginBottom:5}}>{content}</div>
  </div>
}
const Home: React.FC = () => { 
  
  const history = useHistory()

  
  // useEffect(()=>{
  //   history.push('wingo_30s')
  // },[])
  // return <></>
  const {t} = useTranslation()
  return <Page showTopBar={false}>
    <DocumentTitle title='wingoanalyst'/>
    <StyledHomeTopBackgroundWrapper>
      <LotterySegmentTab/>
    </StyledHomeTopBackgroundWrapper>
    <PopularLotteryPrediction />
    <HitRatePanel/>
    <ActiveUserPanel />
    <Advantages />
    <WinningRanks />
    <DescItem content={t('Lottery platform advocates fairness, justice, and openness. We mainly operate fair lottery, blockchain games, live casinos, and slot machine games.')}/>
    <DescItem content={t(`Lottery works with more than 10'000 online live game dealers and slot games, all of which are verified fair games.`)}/>
    <DescItem content={t(`Lottery supports fast deposit and withdrawal, and looks forward to your visit.`)}/>
    <DescItem hideEmphasis content={t(`Gambling can be addictive, please play rationally.`)}/>
    <DescItem hideEmphasis content={t(`Lottery only accepts customers above the age of 18.`)}/>
  </Page>
   
};

const StyledCardWrapper = styled.div`
  background: linear-gradient(157deg,#FA5F5F 0%,#FF8C82 100%);
  filter: drop-shadow(0 .10667rem .21333rem rgba(208,208,237,.36));
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  padding-top: 10px;
  font-size: 25px;
  font-weight: bold;
  text-shadow: 0 .09667rem .05333rem #F74747;
`

const StyledOverview = styled.div`
  align-items: center;
  display: flex;
  @media (max-width: 768px) {
    width: 100%;
    flex-flow: column nowrap;
    align-items: center;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  @media (max-width: 768px) {
    width: 100%;
    flex-flow: column nowrap;
    align-items: center;
  }
`;

const StyledNoticeContainer = styled.div`
  max-width: 768px;
  width: 90vw;
`;

const StyledSpacer = styled.div`
  height: ${(props) => props.theme.spacing[4]}px;
  width: ${(props) => props.theme.spacing[4]}px;
`;

const StyledLink = styled.a`
  font-weight: 700;
  text-decoration: none;
  color: ${(props) => props.theme.color.primary.main};
`;

export default Home;
